module.exports = __webpack_public_path__ + "static/img/driblab_white.2167e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_white.png
// module id = y+CX
// module chunks = 94